import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { EdmundsLogo } from 'site-modules/shared/components/edmunds-logo/edmunds-logo';
import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';
import { HeaderConfigPropTypes } from 'site-modules/shared/components/lead-form/lead-form-prop-types/lead-form-prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { LeadFormMarkdownView } from 'site-modules/shared/components/lead-form/lead-form-markdown-view/lead-form-markdown-view';

export function Header({
  config: { showLogo, srpLink, text, explainingText, showSeparator, className } = {},
  templateParams = [],
}) {
  const classNameValue = applyTemplateParams(templateParams, className);
  const showSeparatorValue = applyTemplateParams(templateParams, showSeparator) === 'true';

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center">
        {showLogo && <EdmundsLogo path={''} />}
        {srpLink && (
          <Link
            to={srpLink.to}
            className="btn btn-outline-primary-b size-14 btn-sm"
            data-tracking-id="view_search_result"
            rel="nofollow"
          >
            {srpLink.text}
          </Link>
        )}
      </div>
      <h2 className={classNames('heading-2 mt-0_5 mb-1_25', classNameValue)}>
        {applyTemplateParams(templateParams, text)}
      </h2>
      {explainingText && (
        <div className="text-gray-darker">
          <LeadFormMarkdownView markdown={explainingText} templateParams={templateParams} />
        </div>
      )}
      {showSeparatorValue && <hr />}
    </Fragment>
  );
}

Header.propTypes = {
  config: HeaderConfigPropTypes.header,
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};
